<template>
  <div class="row">
    <div class="col-12 text-left">
      <div class="text-left content">
        <p>{{ content.index }}</p>
      </div>
    </div>
    <div class="col-12">
      <h2 class="text-center">{{ content.h2 }}</h2>
    </div>
    <div class="countries col-12 row">
      <div
        v-for="item in directions"
        :key="item.key"
        class="country col-6 col-sm-4 col-md-3 q-mb-md relative-position"
      >
        <router-link
          class="country fs-14 link block"
          :to="`/${$route.params.locale}/directions/${item.cache_path}`"
        >
          <div>
            <q-img :src="resizeImage(item.icon_url, 240, 240)" />
          </div>
          {{ item.name }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ResizeImage from 'mixins/ResizeImage';

export default {
  name: 'Directions',
  mixins: [
    ResizeImage,
  ],
  preFetch({ store }) {
    return store.dispatch('directions/fetchDirections');
  },
  computed: {
    content() {
      return this.$t('pages.directions');
    },
    directions() {
      return this.$store.state.directions.directions;
    },
  },
  mounted() {
    this.$store.dispatch('directions/setDirection', null);
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 30px;
}

.country {
  line-height: .9;

  a {
    padding: 0 16px 0 32px;
  }

  div {
    position: absolute;
    left: 0;
    border-radius: 2px;
    box-shadow: 0 0 1px #d3d3d3;
    height: 14px;
    overflow: hidden;
    width: 22px;
  }

  img {
    position: absolute;
    top: -5px;
    left: -1px;
    width: 24px;
  }
}
</style>
